<script>
  import { createEventDispatcher } from "svelte";
  import { navigateTo } from "svelte-router-spa";
  import { Link, TextField, SelectField } from "@saztrek/firefly";
  import { BRANCHES_DETAILED } from "../../../gql";

  import CRUDPage from "../../components/CRUDPage.svelte";
  import { selectOptions } from "../../components/defaultObjects";

  const dispatch = createEventDispatcher();

  const columns = [
    {
      field: "code",
      name: "Code",
      renderComponent: Link,
      resolveProps: (data) => {
        return {
          href: `/branches/edit/${data.code}`
        };
      }
    },
    {
      field: "name",
      name: "Name",
      dataType: "string"
    },
    {
      field: "chain",
      name: "Account",
      renderComponent: Link,
      resolveProps: (data) => {
        return {
          href: `/chains/edit/${data.chain}`
        };
      }
    }
  ];

  const tableActions = [
    {
      icon: "pencil",
      title: "Edit",
      action: (data) => {
        navigateTo(`branches/edit/${data.code}`);
      }
    },
    {
      icon: "trash",
      title: "Inactivate",
      action: (data) => {
        dispatch("inactivateBranch", { code: data.code });
      }
    }
  ];

  const findObjectInput = {
    findBranchInput: {
      code: undefined,
      name: undefined,
      version: undefined
    }
  };

  let code;
  let name;
  let chainCode;
  let isActiveList;

  const resetSearch = () => {
    code = "";
    name = "";
    chainCode = "";
    return {
      findBranchInput: {
        code: undefined,
        name: undefined,
        chainCode: undefined
      }
    };
  };

  const updateSearch = () => {
    return {
      findBranchInput: {
        code: code !== "" ? code : undefined,
        name: name !== "" ? name : undefined,
        chainCode: chainCode !== "" ? chainCode : undefined
      }
    };
  };

  const goToAddAccount = () => {
    navigateTo("branches/new");
  };

  const processResponse = (response) => {
    const processEdges = (edges) => {
      return edges.map((edge) => {
        const { node } = edge;
        return {
          code: node.code,
          name: node.name,
          chain: `${node.chain.code} - ${node.chain.name}`
        };
      });
    };

    const { data } = response;
    const { branches } = data;
    const { edges } = branches;

    return {
      items: processEdges(edges),
      currentData: branches
    };
  };
</script>

<div class="w-full px-10">
  <CRUDPage
    gqlQuery={BRANCHES_DETAILED}
    {columns}
    {tableActions}
    {processResponse}
    {findObjectInput}
    {resetSearch}
    {updateSearch}
    goToAdd={goToAddAccount}>
    <div slot="searchform" class="w-full grid grid-cols-1 md:grid-cols-4 gap-2">
      <TextField type="search" placeholder="Code" bind:textValue={code} />
      <TextField type="search" placeholder="Name" bind:textValue={name} />
      <TextField type="search" placeholder="Chain" bind:textValue={chainCode} />
      <SelectField options={selectOptions} bind:value={isActiveList} />
    </div>
  </CRUDPage>
</div>
